import { Typography, Box } from '@mui/material';
import ExcelUploadSection from './ExcelUploadSection';

const DocsTeachers = () => {
  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Teachers
      </Typography>

      <Typography variant="body1" paragraph>
        Teachers are responsible for conducting the classes. Each teacher must
        be registered in the system and assigned subjects to facilitate accurate
        timetable generation.
      </Typography>

      <Typography variant="h2" gutterBottom>
        Adding a Teacher
      </Typography>

      <ExcelUploadSection />

      <Typography variant="body1" paragraph>
        To add a new teacher, follow these steps:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Navigate to the <strong>Teachers</strong> section in the dashboard.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the department to which the Teacher is associated with.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter a unique code for teacher (e.g., RG, CMB).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter given names for teacher (e.g., Dr. Ross, Chandler Muriel).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Enter the surname (e.g., Geller, Bing).
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Specify where the teacher can teach all the subject of the assigned
            department or not.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click <strong>Save</strong> to add the teacher.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Assigning Subjects
      </Typography>
      <Typography variant="body1" paragraph>
        You can either select <strong>Can Teach All Subjects</strong> as{' '}
        <strong>Yes</strong> via the Edit Teacher option. And/or you can assign
        specific subject to them as needed:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            Click on <strong>Assign Subject</strong> for a particular teacher.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Select the <strong>Subject</strong>.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            Click on <strong>Add</strong>.
          </Typography>
        </li>
      </ul>

      <Typography variant="h2" gutterBottom>
        Managing Teachers
      </Typography>
      <Typography variant="body1" paragraph>
        After adding teachers, you can update or remove them as needed:
      </Typography>
      <ul>
        <li>
          <Typography variant="body1">
            <strong>Editing:</strong> Click on the edit(pencil) button to modify
            teacher details.
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <strong>Deleting:</strong> Click on the edit(pencil) button and
            select delete if they are no longer active.
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default DocsTeachers;
